import axios from "axios";
import { Apis } from "constants/apis";
import { getToken } from "utils/token";

const updateProfile = async (payload: any) => {
    const { data } = await axios.put(Apis.UPDATE_USER, payload, { headers: { Authorization: getToken() } })
    return data
}
export default updateProfile